import { Component, OnInit, HostListener } from '@angular/core';
import { DatabusService } from '../../shared/services/databus.service';
import { DecodeTicketService } from '../../shared/services/decode-ticket.service';
import { ValidationService } from '../../shared/services/validation.service';
import { KeyboardServiceService } from '../../shared/keyboard-service/keyboard-service.service';
import { Idle } from '@ng-idle/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-enterid',
  templateUrl: './enterid.component.html',
  styleUrls: ['./enterid.component.scss']
})
export class EnteridComponent implements OnInit {
  showSpinner: boolean = false;
  fullString: String = '';
  previous: String = null;
  scanComplete: Boolean = false;
  enterEmail: boolean = false;
  scanInvalid: boolean = false;

  signup = {
    email: ''
  }

  constructor (
    private dataSvc: DatabusService,
    private decoder: DecodeTicketService,
    private idle: Idle,
    private validate: ValidationService,
    private router: Router ) { 
    }

  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    
    if ( event.which !== 13 && 
      event.which !== 40 &&
      event.key !== 'Shift' ) {
      this.fullString += event.key;
      this.previous = event.key;
    }

    if ( event.which === 13 && !this.scanComplete ) {
      this.scanComplete = true;
      this.checkScanType(this.fullString);
    }
  }

  checkScanType (scan) {
    this.showSpinner = true;
    let scanLength = scan.split('-').length;
    if(scanLength < 3) {
      this.fullString = '';
      //Show error here
      this.scanInvalid = true;
    } else if (scanLength === 3) {
      this.validate.checkClubCard(scan)
      .then((results) => {
        this.dataSvc.currentClubCard = scan;
        if(results.status === "257") {
          this.RouteToSignup();
        } else if (results.status === "256") {
          this.dataSvc.currentEmail = results.email;
          if(this.dataSvc.currentTicket.code) {
            this.AssignTicket()
          } else {
            this.router.navigate(['/scananother']);
          }
        } else if (results.status === "417") {
          this.showSpinner = false;
          this.dataSvc.errorMessage = results.message;
          this.router.navigate(['/invalid']);
        } else {       
          this.scanInvalid = true;
        }
      })
      .catch((err) => {
        this.showSpinner = false;
        this.router.navigate(['/scanticket']);
      });   
    } else {
      this.scanInvalid = true;
      this.showSpinner = false;
      this.scanComplete = false;
      this.fullString = '';   
    }    
  }

  AssignTicket() {
    let ticket = {
      email: this.dataSvc.currentEmail,
      code: this.dataSvc.currentTicket.code
    }
    this.validate.assignTicketAccount(ticket)
    .then((results) => {
      if(results.status === "204") {
        this.dataSvc.redeemValue = results.value;
        this.router.navigate(['/success']);
      }
      if(results.status === "409") {
        this.dataSvc.errorMessage = results.message;
        this.router.navigate(['/invalid']);
      }
    })    
  }

  RouteToSignup () {
    this.router.navigate(['/addprofile']);
  }

  ShowEmail () {
    this.router.navigate(['/enteremail']);
  }

  EnterEmail () {
    if(this.signup.email && this.signup.email !== '') {
      this.dataSvc.currentEmail = this.signup.email;
      this.RouteToSignup();
    }
  }

  ngOnInit() {
    if (!this.idle.isRunning()) {
      this.idle.watch();
    };
  }
}



// WEBPACK FOOTER //
// C:/Magento2/gs-kiosk/src/app/routes/enterid/enterid.component.ts